import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from 'prosemirror-state';

const pastingFromGoogleDocs = (container) => {
  const element = container.querySelector('b');
  return element?.id?.startsWith('docs-internal-guid');
};

const removeEmptyParagraphsWrapingHrs = (container) => {
  const emptyParagraphs = container.querySelectorAll('hr + p:empty');

  emptyParagraphs.forEach((paragraph) => {
    const hr = paragraph.previousElementSibling;
    const previousEl = hr.previousElementSibling;
    const emptyParagraph = previousEl?.tagName === 'P' && previousEl?.innerHTML === '';

    paragraph.remove();
    emptyParagraph && previousEl.remove();
  });
};

const RemoveHrEmptyParagraphs = Extension.create({
  name: 'setTablesWidth',
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('removeLineBreakDuplicates'),
        props: {
          transformPastedHTML(html, editor) {
            const container = document.createElement('div');
            container.innerHTML = html;

            if (pastingFromGoogleDocs(container)) {
              removeEmptyParagraphsWrapingHrs(container);
            }

            return container.innerHTML;
          },
        },
      }),
    ];
  },
});

export default [RemoveHrEmptyParagraphs];
